<div class="slds-tabs_scoped">
    <ul class="slds-tabs_scoped__nav" role="tablist">
        <ng-content select="uiLightning-tabs-nav"></ng-content>
    </ul>
    <ng-content select="uiLightning-tabs-contents"></ng-content>
</div>